// Override with REACT_APP_TMDB_API_KEY so the key is not tied to the source.
export const TMDB_API_KEY =
  process.env.REACT_APP_TMDB_API_KEY || "1f89b59aebcb2b9372294bd142f836e9";

export const TMDB_BASE = "https://api.themoviedb.org/3";
